import { render, staticRenderFns } from "./AccessMotivation.vue?vue&type=template&id=86d5d4c8&"
import script from "./AccessMotivation.vue?vue&type=script&lang=js&"
export * from "./AccessMotivation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports